/* ==========================================================================
   Elevate Floors — Seção 03: Signature floors

   Só o carrossel mobile. A expansão no hover do desktop é CSS puro.
   Religa em shopify:section:load porque o editor de tema troca o nó da
   section a cada save.
   ========================================================================== */
(function () {
  'use strict';

  function initRoot(root) {
    var rail = root.querySelector('[data-rail]');
    if (!rail || rail._efFloorsBound) return;
    rail._efFloorsBound = true;

    var seg = root.querySelector('[data-seg]');
    var arrows = root.querySelectorAll('.ef-floors__arrow');

    // o passo é medido do próprio card, não fixado em 228: largura e gap são
    // settings do customizer e podem mudar sem tocar neste arquivo
    function step() {
      var card = rail.querySelector('.ef-floor');
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    var ticking = false;
    function sync() {
      ticking = false;
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
      var pos = max > 0 ? rail.scrollLeft / max : 0;

      if (seg) {
        var w = Math.min(ratio, 1) * 100;
        seg.style.width = w.toFixed(2) + '%';
        seg.style.left = (pos * (100 - w)).toFixed(2) + '%';
      }

      arrows.forEach(function (b) {
        var dir = parseInt(b.dataset.dir, 10);
        var off = max <= 0 || (dir < 0 ? rail.scrollLeft <= 4 : rail.scrollLeft >= max - 4);
        b.classList.toggle('is-off', off);
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }

    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        rail.scrollBy({
          left: parseInt(b.dataset.dir, 10) * step(),
          behavior: 'smooth'
        });
      });
    });

    rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sync();
  }

  function init() {
    document.querySelectorAll('.ef-floors').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
